const hex = 16;
const decodeExpression = /\\u([a-zA-Z0-9]{4})/g;

export const decodeEncodedNonAsciiCharacters = (value) =>
  value.replace(decodeExpression, (wholeMatch, group) => String.fromCharCode(parseInt(group, hex)));
